import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { helpCenterSettingsAgentStudioRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsAgentStudioRoute.tsx';
import { AgentOverviewPageSkeleton } from '@atlassian/jira-skeletons/src/ui/help-center/agent-overview-page/AgentOverviewPageSkeleton.tsx';
import {
	AgentStudioOverviewPage,
	LazyAgentStudioOverviewPage,
	csmAgentOverviewPageEntryPoint,
} from './ui/agent-studio/index.tsx';
import { agentStudioNavigation } from './common/constants.tsx';

export const helpCenterSettingsAgentStudioRouteEntry = createEntry(
	helpCenterSettingsAgentStudioRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.agent-studio',

		// For either return undefined scenario, it will fallback to the component config below
		entryPoint() {
			return csmAgentOverviewPageEntryPoint;
		},

		component: AgentStudioOverviewPage,
		skeleton: AgentOverviewPageSkeleton,
		layout: serviceProjectLayout,
		navigation: agentStudioNavigation,
		resources: [...getServiceDeskSettingsResources()],
		forPaint: [LazyAtlassianNavigation, LazyAgentStudioOverviewPage],
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsAgentStudioRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsAgentStudioRouteEntry',
			},

			enabled: true,
		},
	}),
);
